import { useToast } from '@components/index'
import { useAuthentication } from '@features/auth/context'
import { CustomTokenRefresh } from '@features/auth/types'
import { SNA_PREFIX } from '@services/utils'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { apiClient } from '../../api-client'

export function useLogout() {
  const toast = useToast()
  const { logout } = useAuthentication()
  const queryClient = useQueryClient()
  const { t } = useTranslation('auth')

  async function logoutRequest(args: CustomTokenRefresh): Promise<any> {
    const res = await apiClient.post<any>(`${SNA_PREFIX}auth/logout`, args)
    return res.data
  }

  return useMutation({
    mutationFn: logoutRequest,
    // Always clear the local session, even if the server call fails — e.g. the
    // access token already expired after a long idle, so /auth/logout 401s.
    // The user must be logged out regardless of the server's response.
    onSettled: () => {
      logout()
      queryClient.clear()
    },
    onSuccess: () => {
      toast.success({ message: t('logout.success') })
    }
  })
}
